import React, { Component } from 'react';
import { Select, Input, Button, Table, Tooltip } from 'antd';
import { withRouter, } from 'react-router-dom';
import { countrySearchAPI } from '../../api/senatorSearch.js'
import caImg from '../../assets/img/database/ca.png'
import unImg from '../../assets/img/database/un.png'
import ukImg from '../../assets/img/database/uk.png'
import usImg from '../../assets/img/database/us.png'
import ruImg from '../../assets/img/database/ru.png'
import frImg from '../../assets/img/database/fr.png'
import geImg from '../../assets/img/database/ge.png'
import plImg from '../../assets/img/database/polish.png'
import tuImg from '../../assets/img/database/turkish.png'
import indiaImg from '../../assets/img/home/indian.png'
import pakistaniImg from '../../assets/img/home/pakistani.png'
import singaporeanImg from '../../assets/img/home/singaporean.png'
import newzealandImg from '../../assets/img/home/newzealand.png'
import southafricanImg from '../../assets/img/home/southafrican.png'
import austrianImg from '../../assets/img/home/austrian.png'
import malaysianImg from '../../assets/img/home/malaysian.png'
import '../../assets/css/common.css'
import './mycss.css'
import MyBreadcrumb from '../../components/MyBreadcrumb.jsx'

const { Option } = Select;

class SenatorSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currCountry: this.props.match.params.country,
            title: '',
            dataSource: [],
            dateRange: [],
            tbName: '',
            value1: '',    //对应每个国家的input搜索框的顺序填值,
            value2: '',
            value3: '',
            value4: '',
            selectValue1: '',
            colEu: [
                {
                    title: '议员（Member）',
                    dataIndex: 'name',
                    key: 'name',
                    width: 100,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,
                    render: name => (
                        <Tooltip placement="topLeft" title={name}>
                            {name}
                        </Tooltip>
                    ),
                },
                {
                    title: '国家（Country）',
                    dataIndex: 'country',
                    key: 'country',
                    width: 100,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,
                    render: country => (
                        <Tooltip placement="topLeft" title={country}>
                            {country}
                        </Tooltip>
                    ),
                },
                // {
                //     title: '党派（Faction）',
                //     dataIndex: 'faction',
                //     key: 'faction',
                //     width: 180,
                //     sorter: true,
                //     textWrap: 'word-break',
                //     ellipsis: true,
                //     render: faction => (
                //         <Tooltip placement="topLeft" title={faction}>
                //             {faction}
                //         </Tooltip>
                //     ),
                // },
                {
                    title: '党团（Group）',
                    dataIndex: 'group',
                    key: 'group',
                    width: 220,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,
                    render: group => (
                        <Tooltip placement="topLeft" title={group}>
                            {group}
                        </Tooltip>
                    ),
                },
                {
                    title: '详情',
                    dataIndex: '',
                    width: 40,
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/senator/' + this.state.currCountry + '/detail/' + record.auto_id}>详情</a>
                    },
                },
            ],
            colCanada: [
                {
                    title: '议员（Member）', dataIndex: 'name', key: 'name', width: 100, sorter: true, textWrap: 'word-break', ellipsis: true,
                    render: name => (
                        <Tooltip placement="topLeft" title={name}>
                            {name}
                        </Tooltip>
                    ),
                },
                {
                    title: '党派（Affiliation）', dataIndex: 'faction', key: 'faction', width: 120, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: faction => (
                        <Tooltip placement="topLeft" title={faction}>
                            {faction}
                        </Tooltip>
                    ),
                },
                {
                    title: '省份（Province）', dataIndex: 'province', key: 'province', width: 100, sorter: true,
                    textWrap: 'word-break', ellipsis: true, render: province => (
                        <Tooltip placement="topLeft" title={province}>
                            {province}
                        </Tooltip>
                    ),
                },
                {
                    title: '选区（Constituency）', dataIndex: 'constituency', key: 'constituency', width: 160, sorter: true, textWrap: 'word-break',
                    ellipsis: true, render: constituency => (
                        <Tooltip placement="topLeft" title={constituency}>
                            {constituency}
                        </Tooltip>
                    ),
                },
                {
                    title: '详情', dataIndex: '', width: 40,
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/senator/ca/detail/' + record.auto_id}>详情</a>
                    },
                },
            ],
            colUs: [
                {
                    title: '议员（Member）', dataIndex: 'name', key: 'name', width: 100, textWrap: 'word-break', ellipsis: true, sorter: true,
                    render: name => (
                        <Tooltip placement="topLeft" title={name}>
                            {name}
                        </Tooltip>
                    ),
                },
                {
                    title: '议院（Chamber）', dataIndex: 'category', key: 'category', width: 80, sorter: true, textWrap: 'word-break',
                },
                {
                    title: '党派（Party）', dataIndex: 'party', key: 'party', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: party => (
                        <Tooltip placement="topLeft" title={party}>
                            {party}
                        </Tooltip>
                    ),
                },
                {
                    title: '州（State）', dataIndex: 'state', key: 'state', width: 80, sorter: true, textWrap: 'word-break',
                    ellipsis: true, render: state => (
                        <Tooltip placement="topLeft" title={state}>
                            {state}
                        </Tooltip>
                    ),
                },

                {
                    title: '任期(Served)', dataIndex: 'served', key: 'served', width: 100, sorter: true, textWrap: 'word-break',
                    ellipsis: true, render: served => (
                        <Tooltip placement="topLeft" title={served}>
                            {served}
                        </Tooltip>
                    ),
                },
                {
                    title: '详情', dataIndex: '', width: 40,
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/senator/' + this.state.currCountry + '/detail/' + record.auto_id + '?tbName=UsMP'}>详情</a>
                    },
                },
            ],
            colUk: [
                {
                    title: '议员(Member)', dataIndex: 'name', key: 'name', width: 100, textWrap: 'word-break', ellipsis: true, sorter: true,
                    render: name => (
                        <Tooltip placement="topLeft" title={name}>
                            {name}
                        </Tooltip>
                    ),
                },
                {
                    title: '党派（Party）', dataIndex: 'party', key: 'party', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: party => (
                        <Tooltip placement="topLeft" title={party}>
                            {party}
                        </Tooltip>
                    ),
                },
                {
                    title: '选区（Constituency）', dataIndex: 'constituency', key: 'constituency', width: 80, sorter: true, textWrap: 'word-break',
                    ellipsis: true, render: constituency => (
                        <Tooltip placement="topLeft" title={constituency}>
                            {constituency}
                        </Tooltip>
                    ),
                },
                {
                    title: '详情', dataIndex: '', width: 40,
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/senator/' + this.state.currCountry + '/detail/' + record.auto_id + '?tbName=UkMP'}>详情</a>
                    },
                },
            ],
            colTr: [
                {
                    title: '议员(Member)', dataIndex: 'name', key: 'name', width: 100, textWrap: 'word-break', ellipsis: true, sorter: true,
                    render: name => (
                        <Tooltip placement="topLeft" title={name}>
                            {name}
                        </Tooltip>
                    ),
                },
                {
                    title: '党派（Parti）', dataIndex: 'parti', key: 'parti', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: parti => (
                        <Tooltip placement="topLeft" title={parti}>
                            {parti}
                        </Tooltip>
                    ),
                },
                {
                    title: '详情', dataIndex: '', width: 40,
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/senator/' + this.state.currCountry + '/detail/' + record.auto_id + '?tbName=Tr'}>详情</a>
                    },
                },
            ],
            colPl: [
                {
                    title: '议员(Member)', dataIndex: 'name', key: 'name', width: 100, textWrap: 'word-break', ellipsis: true, sorter: true,
                    render: name => (
                        <Tooltip placement="topLeft" title={name}>
                            {name}
                        </Tooltip>
                    ),
                },
                {
                    title: '党派(Lista)', dataIndex: 'lista', key: 'lista', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: lista => (
                        <Tooltip placement="topLeft" title={lista}>
                            {lista}
                        </Tooltip>
                    ),
                },
                {
                    title: '会社(Klub/Koło)', dataIndex: 'klub', key: 'klub', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: klub => (
                        <Tooltip placement="topLeft" title={klub}>
                            {klub}
                        </Tooltip>
                    ),
                },
                {
                    title: '选区(Okręg wyborczy)', dataIndex: 'okreg', key: 'okreg', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: okreg => (
                        <Tooltip placement="topLeft" title={okreg}>
                            {okreg}
                        </Tooltip>
                    ),
                },
                {
                    title: '详情', dataIndex: '', width: 40,
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/senator/' + this.state.currCountry + '/detail/' + record.auto_id + '?tbName=PlMP'}>详情</a>
                    },
                },
            ],
            //法国,德国议会不同, 字段不同
            colFr: [
                {
                    title: '议员(Member)', dataIndex: 'member', key: 'member', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: member => (
                        <Tooltip placement="topLeft" title={member}>
                            {member}
                        </Tooltip>
                    ),
                },
                {
                    title: '议院(Assemblée)', dataIndex: 'category', key: 'category', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: category => (
                        <Tooltip placement="topLeft" title={category}>
                            {category}
                        </Tooltip>
                    ),
                },
                {
                    title: '党团(Groupe)', dataIndex: 'fraction', key: 'fraction', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: fraction => (
                        <Tooltip placement="topLeft" title={fraction}>
                            {fraction}
                        </Tooltip>
                    ),
                },
                {
                    title: '省份(Département)', dataIndex: 'département', key: 'département', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: département => (
                        <Tooltip placement="topLeft" title={département}>
                            {département}
                        </Tooltip>
                    ),
                },
                {
                    title: '选区(Circonscription)', dataIndex: 'circonscription', key: 'circonscription', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: circonscription => (
                        <Tooltip placement="topLeft" title={circonscription}>
                            {circonscription}
                        </Tooltip>
                    ),
                },
                {
                    title: '详情', dataIndex: '', width: 40,
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/senator/' + this.state.currCountry + '/detail/' + record.auto_id + '?tbName=FranceMP'}>详情</a>
                    },
                }
            ],
            colGe: [
                {
                    title: '议员(Member)', dataIndex: 'mitglieder', key: 'mitglieder', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: mitglieder => (
                        <Tooltip placement="topLeft" title={mitglieder}>
                            {mitglieder}
                        </Tooltip>
                    ),
                },
                {
                    title: '议院(Parlament)', dataIndex: 'category', key: 'category', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: category => (
                        <Tooltip placement="topLeft" title={category}>
                            {category}
                        </Tooltip>
                    ),
                },
                {
                    title: '党派(Fraktion)', dataIndex: 'partei', key: 'partei', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: partei => (
                        <Tooltip placement="topLeft" title={partei}>
                            {partei}
                        </Tooltip>
                    ),
                },
                {
                    title: '州(Bundesland)', dataIndex: 'bundesland', key: 'bundesland', width: 70, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: bundesland => (
                        <Tooltip placement="topLeft" title={bundesland}>
                            {bundesland}
                        </Tooltip>
                    ),
                },
                {
                    title: '选区(Wahlkreis)', dataIndex: 'wahlkreise', key: 'wahlkreise', width: 100, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: wahlkreise => (
                        <Tooltip placement="topLeft" title={wahlkreise}>
                            {wahlkreise}
                        </Tooltip>
                    ),
                },
                {
                    title: '职务(Funktion)', dataIndex: 'funktion', key: 'funktion', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: funktion => (
                        <Tooltip placement="topLeft" title={funktion}>
                            {funktion}
                        </Tooltip>
                    ),
                },
                {
                    title: '详情', dataIndex: '', width: 40,
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/senator/' + this.state.currCountry + '/detail/' + record.auto_id + '?tbName=GermanyMP'}>详情</a>
                    },
                }
            ],
            colPk: [
                {
                    title: '议员(Member)', dataIndex: 'member', key: 'member', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: member => (
                        <Tooltip placement="topLeft" title={member}>
                            {member}
                        </Tooltip>
                    ),
                },
                {
                    title: '议院(Chamber)', dataIndex: 'chamber', key: 'chamber', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: (text) => {
                        if (text === 'Se') {
                            return 'Senate'
                        } else if (text === 'Na') {
                            return 'National Assembly'
                        } else {
                            return text
                        }
                    },
                },
                {
                    title: '党派(Party)', dataIndex: 'fraction', key: 'fraction', width: 70, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: fraction => (
                        <Tooltip placement="topLeft" title={fraction}>
                            {fraction}
                        </Tooltip>
                    ),
                },
                {
                    title: '省份(Province)', dataIndex: 'province', key: 'province', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: province => (
                        <Tooltip placement="topLeft" title={province}>
                            {province}
                        </Tooltip>
                    ),
                },
                {
                    title: '选区(Constituency)', dataIndex: 'constituency', key: 'constituency', width: 100, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: constituency => (
                        <Tooltip placement="topLeft" title={constituency}>
                            {constituency}
                        </Tooltip>
                    ),
                },
                {
                    title: '任期(Tenure)', dataIndex: 'tenure', key: 'tenure', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: tenure => (
                        <Tooltip placement="topLeft" title={tenure}>
                            {tenure}
                        </Tooltip>
                    ),
                },
                {
                    title: '详情', dataIndex: '', width: 40,
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/senator/' + this.state.currCountry + '/detail/' + record.auto_id + '?tbName=PkMP'}>详情</a>
                    },
                }
            ],
            colSg: [
                {
                    title: '议员(Member)', dataIndex: 'member', key: 'member', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: mitglieder => (
                        <Tooltip placement="topLeft" title={mitglieder}>
                            {mitglieder}
                        </Tooltip>
                    ),
                },
                {
                    title: '选区(Constituency)', dataIndex: 'constituency', key: 'constituency', width: 100, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: wahlkreise => (
                        <Tooltip placement="topLeft" title={wahlkreise}>
                            {wahlkreise}
                        </Tooltip>
                    ),
                },
                {
                    title: '详情', dataIndex: '', width: 40,
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/senator/' + this.state.currCountry + '/detail/' + record.auto_id + '?tbName=SingaporeMP'}>详情</a>
                    },
                }
            ],
            colNz: [
                {
                    title: '议员(Member)', dataIndex: 'member', key: 'member', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: mitglieder => (
                        <Tooltip placement="topLeft" title={mitglieder}>
                            {mitglieder}
                        </Tooltip>
                    ),
                },
                {
                    title: '党派(Party)', dataIndex: 'fraction', key: 'fraction', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: mitglieder => (
                        <Tooltip placement="topLeft" title={mitglieder}>
                            {mitglieder}
                        </Tooltip>
                    ),
                },
                {
                    title: '选区(Electorate)', dataIndex: 'electorate', key: 'electorate', width: 100, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: wahlkreise => (
                        <Tooltip placement="topLeft" title={wahlkreise}>
                            {wahlkreise}
                        </Tooltip>
                    ),
                },
                {
                    title: '详情', dataIndex: '', width: 40,
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/senator/' + this.state.currCountry + '/detail/' + record.auto_id + '?tbName=NewZealandMP'}>详情</a>
                    },
                }
            ],
            colZa: [
                {
                    title: '议员(Member)', dataIndex: 'member', key: 'member', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: mitglieder => (
                        <Tooltip placement="topLeft" title={mitglieder}>
                            {mitglieder}
                        </Tooltip>
                    ),
                },
                {
                    title: '议院(Chamber)', dataIndex: 'chamber', key: 'chamber', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: (text) => {
                        if (text === 'HP') {
                            return 'National Assembly'
                        } else if (text === 'Bills') {
                            return 'National Council of Provinces'
                        } else {
                            return text
                        }
                    },
                },
                {
                    title: '党派(Party)', dataIndex: 'fraction', key: 'fraction', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: mitglieder => (
                        <Tooltip placement="topLeft" title={mitglieder}>
                            {mitglieder}
                        </Tooltip>
                    ),
                },
                {
                    title: '详情', dataIndex: '', width: 40,
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/senator/' + this.state.currCountry + '/detail/' + record.auto_id + '?tbName=ZaMP'}>详情</a>
                    },
                }
            ],
            colAt: [
                {
                    title: '议员(Member)', dataIndex: 'representative', key: 'representative', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: mitglieder => (
                        <Tooltip placement="topLeft" title={mitglieder}>
                            {mitglieder}
                        </Tooltip>
                    ),
                },
                {
                    title: '议院(Parlament)', dataIndex: 'chamber', key: 'chamber', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true,
                },
                {
                    title: '党派(Fraktion)', dataIndex: 'fraction', key: 'fraction', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: mitglieder => (
                        <Tooltip placement="topLeft" title={mitglieder}>
                            {mitglieder}
                        </Tooltip>
                    ),
                },
                // {
                //     title: '立法期(Legislation Period)', dataIndex: 'legislationperiod', key: 'legislationperiod', width: 80, textWrap: 'word-break', ellipsis: true,
                //     sorter: true, render: mitglieder => (
                //         <Tooltip placement="topLeft" title={mitglieder}>
                //             {mitglieder}
                //         </Tooltip>
                //     ),
                // },
                {
                    title: '州(Bundesland)', dataIndex: 'state', key: 'state', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: mitglieder => (
                        <Tooltip placement="topLeft" title={mitglieder}>
                            {mitglieder}
                        </Tooltip>
                    ),
                },
                {
                    title: '详情', dataIndex: '', width: 40,
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/senator/' + this.state.currCountry + '/detail/' + record.auto_id + '?tbName=AustriaMP'}>详情</a>
                    },
                }
            ],
            colRu: [
                {
                    title: '议员(Member)', dataIndex: 'name', key: 'name', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: mitglieder => (
                        <Tooltip placement="topLeft" title={mitglieder}>
                            {mitglieder}
                        </Tooltip>
                    ),
                },
                {
                    title: '议院(Палата)', dataIndex: 'category', key: 'category', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true,
                },
                {
                    title: '党团(Фракции)', dataIndex: 'Фракция', key: 'Фракция', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: mitglieder => (
                        <Tooltip placement="topLeft" title={mitglieder}>
                            {mitglieder}
                        </Tooltip>
                    ),
                },
                {
                    title: '地区(Регион)', dataIndex: 'Регион', key: 'Регион', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: mitglieder => (
                        <Tooltip placement="topLeft" title={mitglieder}>
                            {mitglieder}
                        </Tooltip>
                    ),
                },
                {
                    title: '出生日期(Дата Рождения)', dataIndex: 'born', key: 'born', width: 80, textWrap: 'word-break', ellipsis: true,
                    // sorter: true, 
                },
                {
                    title: '就任时间(Дата Наделения Полномочнями)', dataIndex: 'tookOffice', key: 'tookOffice', width: 80, textWrap: 'word-break', ellipsis: true,
                    // sorter: true, 
                },
                {
                    title: '卸任时间(Срок Окончания Полномочий)', dataIndex: 'termEnds', key: 'termEnds', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: mitglieder => (
                        <Tooltip placement="topLeft" title={mitglieder}>
                            {mitglieder}
                        </Tooltip>
                    ),
                },
                {
                    title: '详情', dataIndex: '', width: 40,
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/senator/' + this.state.currCountry + '/detail/' + record.auto_id + '?tbName=RuMP'}>详情</a>
                    },
                }
            ],
            colIndia: [
                {
                    title: '议员(Member)', dataIndex: 'member', key: 'member', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: mitglieder => (
                        <Tooltip placement="topLeft" title={mitglieder}>
                            {mitglieder}
                        </Tooltip>
                    ),
                },
                {
                    title: '议院(Sansad)', dataIndex: 'chamber', key: 'chamber', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: (text) => {
                        if (text === 'LS') {
                            return 'Lok Sabha'
                        } else if (text === 'RS') {
                            return 'Rajya Sabha'
                        } else {
                            return text
                        }
                    },
                },
                {
                    title: '党派(Party)', dataIndex: 'fraction', key: 'fraction', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: mitglieder => (
                        <Tooltip placement="topLeft" title={mitglieder}>
                            {mitglieder}
                        </Tooltip>
                    ),
                },
                {
                    title: '邦(State)', dataIndex: 'state', key: 'state', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true, render: mitglieder => (
                        <Tooltip placement="topLeft" title={mitglieder}>
                            {mitglieder}
                        </Tooltip>
                    ),
                },
                {
                    title: '详情', dataIndex: '', width: 40,
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/senator/' + this.state.currCountry + '/detail/' + record.auto_id + '?tbName=IndiaMP'}>详情</a>
                    },
                }
            ],
            colMy: [
                {
                    title: '议员(Member)', dataIndex: 'member', key: 'member', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true,
                },
                {
                    title: '议院(Dewan)', dataIndex: 'category', key: 'category', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true,
                },
                {
                    title: '党派(Parti)', dataIndex: 'fraction', key: 'fraction', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true,
                },
                {
                    title: '任命(Lantikan)', dataIndex: 'state', key: 'state', width: 80, textWrap: 'word-break', ellipsis: true,
                    sorter: true,
                },
                {
                    title: '详情', dataIndex: '', width: 40,
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/senator/' + this.state.currCountry + '/detail/' + record.auto_id + '?tbName=MyMP'}>详情</a>
                    },
                }
            ],
            selectedRowKeys: [],
            total: 0,
            totalPage: 0,
            pageSize: 10,
            totalSelect: 0,
            pageNum: 1,
            keyword: '',
            party: '',
            speaker: '',
            unCountry: '',
            orderBy: '',
            orderHow: '',
        }
    }

    setTitle = () => {
        this.setState({
            title: {
                'ca': '加拿大', 'eu': '欧洲', 'us': '美国', 'uk': '英国', 'fr': '法国', 'ge': '德国', 'pl': '波兰', 'tr': '土耳其',
                'pk': '巴基斯坦', 'sg': '新加坡', 'nz': '新西兰', 'za': '南非', 'at': '奥地利', 'india': '印度', 'ru': '俄罗斯', 'my': '马来西亚'
            }[this.state.currCountry] + '议员'
        })
        this.setState({
            countrySrc: {
                'ca': caImg, 'eu': unImg, 'uk': ukImg, 'us': usImg, 'ru': ruImg, 'fr': frImg, 'ge': geImg, 'pl': plImg, 'tr': tuImg
                , 'pk': pakistaniImg, 'sg': singaporeanImg, 'nz': newzealandImg, 'za': southafricanImg, 'at': austrianImg, 'india': indiaImg, 'my': malaysianImg
            }[this.state.currCountry]
        })
    }

    componentDidMount() {
        this.setTitle()
        this.handleSubmit()
    }

    newHandleSearch = () => {
        this.setState({ pageNum: 1 }, () => {
            this.handleSubmit()
        })
    }

    // 提交搜索请求
    handleSubmit = (e) => {
        const { colEu, colCanada, colUs, colUk, colTr, colPl, colFr, colGe, colPk, colSg, colNz, colZa, colAt, colIndia, colRu, colMy,
            pageSize, pageNum, currCountry } = this.state

        let data = {}
        this.setState({ loading: true }, () => {
            if (currCountry === 'eu') {
                data = {
                    name: this.state.value1,
                    faction: this.state.value2,
                    group: this.state.value3,
                    country: this.state.selectValue1,
                    page_size: pageSize,
                    page_num: pageNum
                }

            } else if (currCountry === 'ca') {
                data = {
                    name: this.state.value1,
                    faction: this.state.value2,
                    keyword: this.state.value3,
                    province: this.state.value4,
                    page_size: pageSize,
                    page_num: pageNum
                }

            }
            else if (currCountry === 'us') {
                data = {
                    tb_name: 'UsMP',
                    name: this.state.value1,
                    party: this.state.value2,
                    state: this.state.value3,
                    page_size: pageSize,
                    page_num: pageNum
                }
            }
            else if (currCountry === 'uk') {
                data = {
                    name: this.state.value1,
                    party: this.state.value2,
                    constituency: this.state.value3,
                    tb_name: 'UkMP',
                    page_size: pageSize,
                    page_num: pageNum
                }
            }
            else if (currCountry === 'ru') {
                data = {
                    name: this.state.value1,
                    Фракция: this.state.value2,
                    Регион: this.state.value3,
                    category: this.state.selectValue1,
                    tb_name: 'RuMP',
                    page_size: pageSize,
                    page_num: pageNum
                }
            }
            else if (currCountry === 'pl') {
                data = {
                    name: this.state.value1,
                    lista: this.state.value2,
                    klub: this.state.value3,
                    tb_name: 'PlMP',
                    page_size: pageSize,
                    page_num: pageNum
                }

            }
            else if (currCountry === 'tr') {
                data = {
                    name: this.state.value1,
                    parti: this.state.value2,
                    tb_name: 'Tr',
                    page_size: pageSize,
                    page_num: pageNum
                }

            }//法国
            else if (currCountry === 'fr') {
                data = {
                    tb_name: 'FranceMP',
                    member: this.state.value1,
                    fraction: this.state.value2,
                    circonscription: this.state.value3,
                    category: this.state.selectValue1,
                    page_size: pageSize,
                    page_num: pageNum
                }

            }//德国
            else if (currCountry === 'ge') {
                data = {
                    tb_name: 'GermanyMP',
                    mitglieder: this.state.value1,
                    partei: this.state.value2,
                    bundesland: this.state.value3,
                    category: this.state.selectValue1,
                    page_size: pageSize,
                    page_num: pageNum
                }
            }//巴基斯坦
            else if (currCountry === 'pk') {
                data = {
                    tb_name: 'PkMP',
                    member: this.state.value1,
                    fraction: this.state.value2,
                    province: this.state.value3,
                    constituency: this.state.value4,
                    chamber: this.state.selectValue1,
                    page_size: pageSize,
                    page_num: pageNum
                }

            }
            else if (currCountry === 'sg') {
                data = {
                    tb_name: 'SingaporeMP',
                    member: this.state.value1,
                    constituency: this.state.value2,
                    page_size: pageSize,
                    page_num: pageNum
                }
            }
            else if (currCountry === 'nz') {
                data = {
                    tb_name: 'NewZealandMP',
                    member: this.state.value1,
                    fraction: this.state.value2,
                    electorate: this.state.value3,
                    page_size: pageSize,
                    page_num: pageNum
                }

            }
            else if (currCountry === 'za') {
                data = {
                    tb_name: 'ZaMP',
                    member: this.state.value1,
                    fraction: this.state.value2,
                    chamber: this.state.selectValue1,
                    page_size: pageSize,
                    page_num: pageNum
                }

            }
            else if (currCountry === 'at') {
                data = {
                    tb_name: 'AustriaMP',
                    representative: this.state.value1,
                    fraction: this.state.value2,
                    state: this.state.value3,
                    chamber: this.state.selectValue1,
                    page_size: pageSize,
                    page_num: pageNum
                }

            }
            else if (currCountry === 'india') {
                data = {
                    tb_name: 'IndiaMP',
                    member: this.state.value1,
                    fraction: this.state.value2,
                    state: this.state.value3,
                    chamber: this.state.selectValue1,
                    page_size: pageSize,
                    page_num: pageNum
                }
            }
            else if (currCountry === 'my') {
                data = {
                    tb_name: 'MyMP',
                    member: this.state.value1,
                    fraction: this.state.value2,
                    state: this.state.value3,
                    category: this.state.selectValue1,
                    page_size: pageSize,
                    page_num: pageNum
                }
            }
            if (this.state.orderBy && this.state.orderBy.length > 0) {
                data.order_by = this.state.orderBy
                data.order = this.state.orderHow && this.state.orderHow.length > 0 ? this.state.orderHow.slice(0, -3) : ''
            }
            let columns = {
                'us': colUs, 'ca': colCanada, 'eu': colEu, 'uk': colUk, 'fr': colFr, 'ge': colGe, 'pl': colPl, 'tr': colTr,
                'pk': colPk, 'sg': colSg, 'nz': colNz, 'za': colZa, 'at': colAt, 'india': colIndia, 'ru': colRu, 'my': colMy
            }[this.state.currCountry]
            countrySearchAPI(this.state.currCountry, data)
                .then(res => {
                    this.setState({
                        columns: columns,
                        dataSource: res.data.data.data,
                        total: res.data.data.total,
                        totalPage: res.data.data.page_info.total_page,
                        loading: false,
                    })
                    document.body.scrollTop = 0; // For Safari
                    document.documentElement.scrollTop = 0;
                })
                .catch(err => {
                    this.setState({ loading: false })
                })
        })

    }

    handlePageSizeChange = (current, pageSize) => {
        this.setState({ pageSize }, () => {
            this.handleSubmit()
        })
    }

    handlePageNumChange = (pageNum) => {
        this.setState({ pageNum }, () => {
            this.handleSubmit()
        })
    }

    handleChangeKeyword = (e) => {
        this.setState({ keyword: e.target.value })
        if (e.type === 'click' && e.target.value === '') {
            this.newHandleSearch()
        }
    }

    handleChangeParty = (e) => {
        this.setState({ party: e.target.value })
        if (e.type === 'click' && e.target.value === '') {
            this.newHandleSearch()
        }
    }

    handleChangeGroup = (e) => {
        this.setState({ group: e.target.value })
        if (e.type === 'click' && e.target.value === '') {
            this.newHandleSearch()
        }
    }

    handleChangeSpeaker = (e) => {
        this.setState({ speaker: e.target.value })
        if (e.type === 'click' && e.target.value === '') {
            this.newHandleSearch()
        }
    }

    handleChangeValue1 = (e) => {
        this.setState({ value1: e.target.value })
        //点击清空小图标,清空input时触发查询
        if (e.type === 'click' && e.target.value === '') {
            this.newHandleSearch()
        }
    }
    handleChangeValue2 = (e) => {
        this.setState({ value2: e.target.value })
        //点击清空小图标,清空input时触发查询
        if (e.type === 'click' && e.target.value === '') {
            this.newHandleSearch()
        }
    }
    handleChangeValue3 = (e) => {
        //点击清空小图标,清空input时触发查询
        this.setState({ value3: e.target.value })
        if (e.type === 'click' && e.target.value === '') {
            this.newHandleSearch()
        }
    }
    handleChangeValue4 = (e) => {
        //点击清空小图标,清空input时触发查询
        this.setState({ value4: e.target.value })
        if (e.type === 'click' && e.target.value === '') {
            this.newHandleSearch()
        }
    }

    handleSelectCountry = (value) => {
        this.setState({ unCountry: value })
        this.handleSubmit()
    }

    handleSelect1 = (value) => {
        this.setState({ selectValue1: value })
        this.newHandleSearch()
    }

    handleTableChange = (pagination, filters, sorter, extra) => {
        if (sorter) {
            this.setState({ orderBy: sorter.field, orderHow: sorter.order }, () => {
                console.log('senator:' + JSON.stringify(sorter));
                this.handleSubmit()
            })
        }
    }

    handleSelectChange = (selectedRowKeys) => {
        this.setState({ selectedRowKeys, totalSelect: selectedRowKeys.length });
    };
    render() {
        const { title, dataSource, columns, total, totalPage, currCountry, countrySrc, loading } = this.state

        const tableEle = (
            <div style={{ padding: '20px 0' }}>
                <span style={{ marginTop: 10, display: 'inline-block' }}>
                    <span>共 <strong style={{ color: '#144db9' }}>{totalPage}</strong> 页，</span>
                    <strong style={{ color: '#144db9' }}>{total}</strong> 条结果
                </span>
                <Table className="tbl-res"
                    locale={{ emptyText: ' ' }} loading={{ tip: "数据加载中 ...", spinning: loading }}
                    dataSource={dataSource} columns={columns} rowKey={record => record.auto_id}
                    scroll={{ x: '100%', scrollToFirstRowOnChange: true }}
                    onChange={this.handleTableChange}
                    style={{ margin: '20px auto', width: '100%' }}
                    sortDirections={['ascend', 'descend', 'ascend']}
                    pagination={{ current: this.state.pageNum, showQuickJumper: true, total: total, onChange: this.handlePageNumChange, onShowSizeChange: this.handlePageSizeChange, showSizeChanger: true, position: ['bottomCenter'] }}
                />
            </div>
        )

        const caEle = (
            <>
                <div style={{ marginTop: 20 }}>
                    <Input className="search-ele" allowClear placeholder="Member" onChange={this.handleChangeValue1} size="large" onPressEnter={this.newHandleSearch} />
                    <Input className="search-ele" allowClear placeholder="Affiliation" onChange={this.handleChangeValue2} size="large" onPressEnter={this.newHandleSearch} style={{ marginLeft: 10 }} />
                    <Input className="search-ele" allowClear placeholder="Constituency" onChange={this.handleChangeValue3} size="large" onPressEnter={this.newHandleSearch} style={{ marginLeft: 10 }} />
                    <Input className="search-ele" allowClear placeholder="Province" onChange={this.handleChangeValue4} size="large" onPressEnter={this.newHandleSearch} style={{ marginLeft: 10 }} />

                    <Button className="btn-submit" style={{ marginLeft: 10, verticalAlign: 'top' }} onClick={this.newHandleSearch} >搜索</Button>
                </div>
            </>
        )

        const usEle = (
            <>
                <div style={{ marginTop: 20 }}>
                    <Input className="senator search-ele" allowClear placeholder="Member" onChange={this.handleChangeValue1} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Input className="senator search-ele" allowClear placeholder="Party" onChange={this.handleChangeValue2} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Input className="senator search-ele" allowClear placeholder="State" onChange={this.handleChangeValue3} size="large" onPressEnter={this.handleSnewHandleSearchubmit} style={{ marginRight: 10 }} />
                    <Button className="btn-submit" style={{ verticalAlign: 'top' }} onClick={this.newHandleSearch} >搜索</Button>
                </div>
            </>
        )
        const ukEle = (
            <>
                <div style={{ marginTop: 20 }}>
                    <Input className="senator search-ele" allowClear placeholder="Member" onChange={this.handleChangeValue1} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Input className="senator search-ele" allowClear placeholder="Party" onChange={this.handleChangeValue2} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Input className="senator search-ele" allowClear placeholder="Constituency" onChange={this.handleChangeValue3} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Button className="btn-submit" style={{ verticalAlign: 'top' }} onClick={this.newHandleSearch} >搜索</Button>
                </div>
            </>
        )
        const trEle = (
            <>
                <div style={{ marginTop: 20 }}>
                    <Input className="senator search-ele" allowClear placeholder="Member" onChange={this.handleChangeValue1} size="large" onPressEnter={this.handleSunewHandleSearchbmit} style={{ marginRight: 10 }} />
                    <Input className="senator search-ele" allowClear placeholder="Parti" onChange={this.handleChangeValue2} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Button className="btn-submit" style={{ verticalAlign: 'top' }} onClick={this.newHandleSearch} >搜索</Button>
                </div>
            </>
        )
        const plEle = (
            <>
                <div style={{ marginTop: 20 }}>
                    <Input className="senator search-ele" allowClear placeholder="Member" onChange={this.handleChangeValue1} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Input className="senator search-ele" allowClear placeholder="Lista" onChange={this.handleChangeValue2} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Input className="senator search-ele" allowClear placeholder="Klub/Koło" onChange={this.handleChangeValue3} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Button className="btn-submit" style={{ verticalAlign: 'top' }} onClick={this.newHandleSearch} >搜索</Button>
                </div>
            </>
        )
        const frEle = (
            <>
                <div style={{ marginTop: 20 }}>
                    <Input className="senator search-ele" allowClear placeholder="Member" onChange={this.handleChangeValue1} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Input className="senator search-ele" allowClear placeholder="Groupe" onChange={this.handleChangeValue2} size="large" onPressEnter={this.handlnewHandleSearcheSubmit} style={{ marginRight: 10 }} />
                    <Input className="senator search-ele" allowClear placeholder="Circonscription" onChange={this.handleChangeValue3} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Button className="btn-submit" style={{ verticalAlign: 'top' }} onClick={this.newHandleSearch} >搜索</Button>
                </div>
                <div style={{ marginTop: 20 }}>
                    <Select style={{ width: `calc((100% - 90px) / 4 - 10px)`, }} placeholder="Assemblée" allowClear onChange={this.handleSelect1}>
                        <Option value="">All</Option>
                        <Option value="Assemblee">Assemblée Nationale</Option>
                        <Option value="Senat">Sénat</Option>
                    </Select>
                </div>
            </>
        )
        const ruEle = (
            <>
                <div style={{ marginTop: 20 }}>
                    <Input className="senator search-ele" allowClear placeholder="Member" onChange={this.handleChangeValue1} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Input className="senator search-ele" allowClear placeholder="Фракции" onChange={this.handleChangeValue2} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Input className="senator search-ele" allowClear placeholder="Области" onChange={this.handleChangeValue3} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Button className="btn-submit" style={{ verticalAlign: 'top' }} onClick={this.newHandleSearch} >搜索</Button>
                </div>
                <div style={{ marginTop: 20 }}>
                    <Select style={{ width: `calc((100% - 90px) / 4 - 10px)`, }} placeholder="Палата" allowClear onChange={this.handleSelect1}>
                        <Option value="">All</Option>
                        <Option value="Council">Council</Option>
                        <Option value="Duma">Duma</Option>
                    </Select>
                </div>
            </>
        )
        const geEle = (
            <>
                <div style={{ marginTop: 20 }}>
                    <Input className="senator search-ele" allowClear placeholder="Member" onChange={this.handleChangeValue1} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Input className="senator search-ele" allowClear placeholder="Fraktion" onChange={this.handleChangeValue2} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Input className="senator search-ele" allowClear placeholder="Bundesland" onChange={this.handleChangeValue3} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Button className="btn-submit" style={{ verticalAlign: 'top' }} onClick={this.newHandleSearch} >搜索</Button>
                </div>
                <div style={{ marginTop: 20 }}>
                    <Select style={{ width: `calc((100% - 90px) / 4 - 10px)`, }} placeholder="Parlament" allowClear onChange={this.handleSelect1}>
                        <Option value="">All</Option>
                        <Option value="Bundestag">Bundestag</Option>
                        <Option value="Bundesrat">Bundesrat</Option>
                    </Select>
                </div>
            </>
        )
        const unEle = (
            <>
                <div style={{ marginTop: 20 }}>
                    <Input className="senator search-ele" allowClear placeholder="Member" onChange={this.handleChangeValue1} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    {/* <Input className="party search-ele" allowClear placeholder="Faction" onChange={this.handleChangeValue2} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} /> */}
                    <Input className="group search-ele" allowClear placeholder="Group" onChange={this.handleChangeValue3} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Button className="btn-submit" style={{ verticalAlign: 'top' }} onClick={this.newHandleSearch} >搜索</Button>
                </div>
                <div style={{ marginTop: 20 }}>
                    <Select style={{ width: `calc((100% - 90px) / 4 - 10px)`, }} placeholder="Country" allowClear onChange={this.handleSelect1}>
                        <Option value="">All</Option>
                        <Option value="Austria">Austria</Option>
                        <Option value="Belgium">Belgium</Option>
                        <Option value="Bulgaria">Bulgaria</Option>
                        <Option value="Croatia">Croatia</Option>
                        <Option value="Cyprus">Cyprus</Option>
                        <Option value="Czechia">Czechia</Option>
                        <Option value="Denmark">Denmark</Option>
                        <Option value="Estonia">Estonia</Option>
                        <Option value="Finland">Finland</Option>
                        <Option value="France">France</Option>
                        <Option value="Germany">Germany</Option>
                        <Option value="Greece">Greece</Option>
                        <Option value="Hungary">Hungary</Option>
                        <Option value="Ireland">Ireland</Option>
                        <Option value="Italy">Italy</Option>
                        <Option value="Latvia">Latvia</Option>
                        <Option value="Lithuania">Lithuania</Option>
                        <Option value="Luxembourg">Luxembourg</Option>
                        <Option value="Malta">Malta</Option>
                        <Option value="Netherlands">Netherlands</Option>
                        <Option value="Poland">Poland</Option>
                        <Option value="Portugal">Portugal</Option>
                        <Option value="Romania">Romania</Option>
                        <Option value="Slovakia">Slovakia</Option>
                        <Option value="Slovenia">Slovenia</Option>
                        <Option value="Spain">Spain</Option>
                        <Option value="Sweden">Sweden</Option>
                    </Select>
                </div>
            </>
        )
        const pkEle = (
            <>
                <div style={{ marginTop: 20 }}>
                    <Input className="senator search-ele" allowClear placeholder="Member" onChange={this.handleChangeValue1} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Input className="senator search-ele" allowClear placeholder="Party" onChange={this.handleChangeValue2} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Input className="senator search-ele" allowClear placeholder="Province" onChange={this.handleChangeValue3} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Input className="senator search-ele" allowClear placeholder="Constituency" onChange={this.handleChangeValue4} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Button className="btn-submit" style={{ verticalAlign: 'top' }} onClick={this.newHandleSearch} >搜索</Button>
                </div>
                <div style={{ marginTop: 20 }}>
                    <Select style={{ width: `calc((100% - 90px) / 4 - 10px)`, }} placeholder="Chamber" allowClear onChange={this.handleSelect1}>
                        <Option value="">All</Option>
                        <Option value="Se">Senate</Option>
                        <Option value="Na">National Assembly</Option>
                    </Select>
                </div>
            </>
        )
        const sgEle = (
            <>
                <div style={{ marginTop: 20 }}>
                    <Input className="senator search-ele" allowClear placeholder="Member" onChange={this.handleChangeValue1} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Input className="senator search-ele" allowClear placeholder="Constituency" onChange={this.handleChangeValue2} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Button className="btn-submit" style={{ verticalAlign: 'top' }} onClick={this.newHandleSearch} >搜索</Button>
                </div>
            </>
        )
        const nzEle = (
            <>
                <div style={{ marginTop: 20 }}>
                    <Input className="senator search-ele" allowClear placeholder="Member" onChange={this.handleChangeValue1} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Input className="senator search-ele" allowClear placeholder="Party" onChange={this.handleChangeValue2} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Input className="senator search-ele" allowClear placeholder="Electorate" onChange={this.handleChangeValue3} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Button className="btn-submit" style={{ verticalAlign: 'top' }} onClick={this.newHandleSearch} >搜索</Button>
                </div>
            </>
        )
        const zaEle = (
            <>
                <div style={{ marginTop: 20 }}>
                    <Input className="senator search-ele" allowClear placeholder="Member" onChange={this.handleChangeValue1} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Input className="senator search-ele" allowClear placeholder="Party" onChange={this.handleChangeValue2} size="large" onPressEnter={this.handlnewHandleSearcheSubmit} style={{ marginRight: 10 }} />
                    <Button className="btn-submit" style={{ verticalAlign: 'top' }} onClick={this.newHandleSearch} >搜索</Button>
                </div>
                <div style={{ marginTop: 20 }}>
                    <Select style={{ width: `calc((100% - 90px) / 4 - 10px)`, }} placeholder="Chamber" allowClear onChange={this.handleSelect1}>
                        <Option value="">All</Option>
                        <Option value="HP">National Assembly</Option>
                        <Option value="Bills">National Council of Provinces</Option>
                    </Select>
                </div>
            </>
        )
        const atEle = (
            <>
                <div style={{ marginTop: 20 }}>
                    <Input className="senator search-ele" allowClear placeholder="Member" onChange={this.handleChangeValue1} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Input className="senator search-ele" allowClear placeholder="Fraktion" onChange={this.handleChangeValue2} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Input className="senator search-ele" allowClear placeholder="Bundesland" onChange={this.handleChangeValue3} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />

                    <Button className="btn-submit" style={{ verticalAlign: 'top' }} onClick={this.newHandleSearch} >搜索</Button>
                </div>
                <div style={{ marginTop: 20 }}>
                    <Select style={{ width: `calc((100% - 90px) / 4 - 10px)`, }} placeholder="Chamber" allowClear onChange={this.handleSelect1}>
                        <Option value="">All</Option>
                        <Option value="NR">NR</Option>
                        <Option value="BR">BR</Option>

                    </Select>
                </div>
            </>
        )
        const indiaEle = (
            <>
                <div style={{ marginTop: 20 }}>
                    <Input className="senator search-ele" allowClear placeholder="Member" onChange={this.handleChangeValue1} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Input className="senator search-ele" allowClear placeholder="Party" onChange={this.handleChangeValue2} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Input className="senator search-ele" allowClear placeholder="State" onChange={this.handleChangeValue3} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />

                    <Button className="btn-submit" style={{ verticalAlign: 'top' }} onClick={this.newHandleSearch} >搜索</Button>
                </div>
                <div style={{ marginTop: 20 }}>
                    <Select style={{ width: `calc((100% - 90px) / 4 - 10px)`, }} placeholder="Sansad" allowClear onChange={this.handleSelect1}>
                        <Option value="">All</Option>
                        <Option value="LS">Lok Sabha</Option>
                        <Option value="RS">Rajya Sabha</Option>
                    </Select>
                </div>
            </>
        )
        const myEle = (
            <>
                <div style={{ marginTop: 20 }}>
                    <Input className="senator search-ele" allowClear placeholder="Member" onChange={this.handleChangeValue1} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Input className="senator search-ele" allowClear placeholder="Parti" onChange={this.handleChangeValue2} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />
                    <Input className="senator search-ele" allowClear placeholder="Lantikan" onChange={this.handleChangeValue3} size="large" onPressEnter={this.newHandleSearch} style={{ marginRight: 10 }} />

                    <Button className="btn-submit" style={{ verticalAlign: 'top' }} onClick={this.newHandleSearch} >搜索</Button>
                </div>
                <div style={{ marginTop: 20 }}>
                    <Select style={{ width: `calc((100% - 90px) / 4 - 10px)`, }} placeholder="Dewan" allowClear onChange={this.handleSelect1}>
                        <Option value="">All</Option>
                        <Option value="Dewan Negara">Dewan Negara</Option>
                        <Option value="Dewan Rakyat">Dewan Rakyat</Option>
                    </Select>
                </div>
            </>
        )
        let searchEle = <></>
        if (currCountry === 'ca') {
            searchEle = caEle
        } else if (currCountry === 'eu') {
            searchEle = unEle
        } else if (currCountry === 'us') {
            searchEle = usEle
        } else if (currCountry === 'uk') {
            searchEle = ukEle
        } else if (currCountry === 'pl') {
            searchEle = plEle
        } else if (currCountry === 'tr') {
            searchEle = trEle
        } else if (currCountry === 'fr') {
            searchEle = frEle
        } else if (currCountry === 'ge') {
            searchEle = geEle
        } else if (currCountry === 'pk') {
            searchEle = pkEle
        } else if (currCountry === 'sg') {
            searchEle = sgEle
        } else if (currCountry === 'nz') {
            searchEle = nzEle
        } else if (currCountry === 'za') {
            searchEle = zaEle
        } else if (currCountry === 'at') {
            searchEle = atEle
        } else if (currCountry === 'india') {
            searchEle = indiaEle
        } else if (currCountry === 'ru') {
            searchEle = ruEle
        } else if (currCountry === 'my') {
            searchEle = myEle
        }

        return (
            <div style={{ margin: '40px 15%', }}>
                <MyBreadcrumb urls={[
                    {
                        url: '/database/senator/' + currCountry, breadcrumbName: {
                            'ca': '加拿大议员', 'eu': '欧洲议员', 'us': '美国议员', 'uk': '英国议员', 'fr': '法国议员', 'ge': '德国议员', 'pl': '波兰议员', 'tr': '土耳其议员',
                            'pk': '巴基斯坦议员', 'sg': '新加坡议员', 'nz': '新西兰议员', 'za': '南非议员', 'at': '奥地利议员', 'india': '印度议员', 'ru': '俄罗斯议员', 'my': '马来西亚议员'
                        }[currCountry] + '数据库'
                    },
                ]} />
                <div className="major-heading" style={{ textAlign: 'left', color: '#144db9', fontSize: 18, }}>
                    <img src={countrySrc} alt="" style={{ marginRight: 10, marginTop: -4, height: 18, }} />
                    {title}
                </div>
                {searchEle}
                {tableEle}
            </div>
        );
    }
}

export default withRouter(SenatorSearch)
